import {Component, OnInit, Input, Output, EventEmitter, ElementRef, SimpleChanges, OnChanges, OnDestroy, ViewChildren} from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FormValidatorUtils } from '../../../shared/utils';
import * as _ from 'lodash';
import { DragulaService } from 'ng2-dragula';
import { StringUtils} from '../../../shared/utils/src/string.utils';
import { ValidatorUtils} from '../../../shared/utils/src/validator.utils';

@Component({
    selector: 'service-route-rule-component',
    templateUrl: './service-route-rule.component.html'
})

export class ServiceRouteRuleComponent implements OnInit, OnChanges, OnDestroy {
    @ViewChildren('serviceSelect') serviceSelects: any;

    @Input() msgSpecSelectConfig: any;
    @Input() oprTypeSelectConfig: any;
    @Input() serviceSelectConfig: any;
    @Input() public ruleInfo = [];
    @Input() public isEditable: boolean;
    @Input() defaultServiceTrgtNo: any;
    @Output() public routeNotUse: EventEmitter<any> = new EventEmitter();

    cndVal: string;
    ruleIndex = 0;

    isNullServiceRouteCndVal = false;       //비교값 null체크
    isNullServiceRouteTarget = false;       //서비스값 null체크

    //public ruleInfo = [];

    constructor(private fb: FormBuilder,
                public element: ElementRef,
                private dragulaService: DragulaService) {

        dragulaService.drop.subscribe((value: any) => {
            if (value[0] === 'serviceRoutingRule') {
                this.resetOrdrNo();
            }
        });

        dragulaService.setOptions('serviceRoutingRule', {
            moves: function (el, container, handle) {
                return handle.className === 'dragable_button dragable_flag';
            }
        });
    }

    ngOnInit() {}

    ngOnChanges(changes: SimpleChanges) {
        this.isNullServiceRouteCndVal = false;
        /*this.ruleIndex = 0;
        this.ruleInfo = [];*/
    }

    ngOnDestroy() {
        this.dragulaService.destroy('serviceRoutingRule');
    }

    public ruleSetAdd() {
        this.ruleIndex++;

        this.ruleInfo.push({
            'ordrNo': this.ruleIndex,
            'cndVal': ''
        });

        this.resetOrdrNo();
    }

    public ruleSetRemove(event, ordrNo) {
        _.remove(this.ruleInfo, {ordrNo : ordrNo});

        this.resetOrdrNo();
    }

    public resetOrdrNo() {
        this.ruleIndex = 0;

        this.ruleInfo.forEach((ruleSet, index) => {
            index++;
            ruleSet.ordrNo = index;
            this.ruleIndex = index;
        });

        if (this.ruleIndex === 0) {
            this.routeNotUse.emit('serviceRoute');
        }
    }

    public getRuleInfo(): any {
        const _serviceRouteRuleInfo = [];
        let maxServiceOrdrNo = 0;
        // $('#serviceRoute tbody tr').each(function (_index) {
        //     const serviceRouteRule = {
        //         ordrNo: _index + 1,                                                 //룰셋팅 순번
        //         cndCnnTypeCd: _index === 0 ? 'RUCDCN10' : 'RUCDCN20',               //첫번째룰은 if 두번째룰은 else if
        //         msgSpecFildNo: $(this).find('#msgSpecList option:selected').val(),
        //         oprTypeCd: $(this).find('#oprTypeList option:selected').val(),
        //         cndVal: $(this).find('#serviceCndVal').val().trim(),
        //         cndValAryYn: 'N',
        //         cndValSprtnChaVal: '',
        //         routTrgtNo: $(this).find('#serviceList option:selected').val()
        //     };
        //     maxServiceOrdrNo = _index + 1;
        //     _serviceRouteRuleInfo.push(serviceRouteRule);
        // });

        this.ruleInfo.forEach((ruleSet: any, _index) => {
            const serviceRouteRule = {
                ordrNo: _index + 1,                                                 //룰셋팅 순번
                cndCnnTypeCd: _index === 0 ? 'RUCDCN10' : 'RUCDCN20',               //첫번째룰은 if 두번째룰은 else if
                msgSpecFildNo: !ruleSet.msgSpecFildNo ? '10006' : ruleSet.msgSpecFildNo,
                oprTypeCd: !ruleSet.oprTypeCd ? 'COPR090' : ruleSet.oprTypeCd,
                cndVal: ruleSet.cndVal,
                cndValAryYn: 'N',
                cndValSprtnChaVal: '',
                routTrgtNo: ruleSet.routTrgtNo
            };
            maxServiceOrdrNo = _index + 1;
            _serviceRouteRuleInfo.push(serviceRouteRule);
        });

        _serviceRouteRuleInfo.push({
            ordrNo: maxServiceOrdrNo + 1,                                         //룰셋팅 순번
            cndCnnTypeCd: 'RUCDCN30',
            msgSpecFildNo: 0,
            oprTypeCd: '-',
            cndVal: '-',
            cndValAryYn: 'N',
            cndValSprtnChaVal: '',
            routTrgtNo: this.defaultServiceTrgtNo
            // routTrgtNo: $('#defaultServiceList option:selected').val()
        });

        return _serviceRouteRuleInfo;
    }

    public validation() {
        this.isNullServiceRouteCndVal = false;
        this.isNullServiceRouteTarget = false;

        let serviceRouteValidation = true;
        const serviceRouteTargetValidation = false;

        this.ruleInfo.forEach((ruleSet, index) => {
            if (StringUtils.isEmpty(ruleSet.cndVal)) {
                ruleSet.isInvalid = true;
                ruleSet.isNullCndVal = true;
                ruleSet.isMaxLenCndVal = false;

                serviceRouteValidation = false;
            } else if (StringUtils.checkMaxStr(ruleSet.cndVal, 200)) {
                ruleSet.isInvalid = true;
                ruleSet.isNullCndVal = false;
                ruleSet.isMaxLenCndVal = true;

                serviceRouteValidation = false;
            } else {
                ruleSet.isInvalid = false;
                ruleSet.isNullCndVal = false;
                ruleSet.isMaxLenCndVal = false;
            }

        });

        this.serviceSelects.forEach((select, index) => {
            if (!select.validation()) {
                serviceRouteValidation = false;
            }
        });
        /*$('#serviceRoute tbody tr').each(function (_index) {
            if ($(this).find('#serviceList option:selected').val() === '' ) {
                serviceRouteValidation = false;
                serviceRouteTargetValidation = true;
            }
        });*/

        if ($('#defaultServiceList option:selected').val() === '') {
            serviceRouteValidation = false;
        }

        this.isNullServiceRouteTarget = serviceRouteTargetValidation;
        return serviceRouteValidation;
    }

    public getRuleInfoLength() {
        return this.ruleInfo.length;
    }

    msgSpecFildNoChanged(event, ruleSet) {
        ruleSet.msgSpecFildNo = event;
    }

    oprTypeCdChanged(event, ruleSet) {
        ruleSet.oprTypeCd = event;
    }

    serviceCndValChanged(ruleSet) {
        if (StringUtils.isEmpty(ruleSet.cndVal)) {
            ruleSet.isInvalid = true;
        } else {
            ruleSet.isInvalid = false;
        }
    }

    serviceSelectChanged(event, ruleSet) {
        ruleSet.routTrgtNo = event.id;
        this.serviceSelects.forEach((select, index) => {
            select.validation();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/ruleSet/service-route-rule/service-route-rule.component.ts